import { Divider, Grid, Typography } from "@mui/material";
import TalentProfilePicture from "../../../talentBasicInfo/TalentProfilePicture";
import { getTalentFullName } from "../../../../../../app/common";
import ChipList from "../../../../../../common/components/functional/chipList/ChipList";
import { Talent } from "../../../../../talents/talentAPI";
import { ChipListProps } from "../../../../../../common/components/functional/chipList/types";
import { useTranslation } from "react-i18next";

type Props = {
  talent: Talent;
  title?: string;
  chipListProps: ChipListProps<Record<string, any>>;
};

const TalentWorkTitleSelector = ({ talent, title, chipListProps }: Props) => {
  const { t } = useTranslation("talentProfile");
  const talentFullName = getTalentFullName(talent);

  return (
    <>
      {title && (
        <Grid item xs={12}>
          <Typography>{title}</Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={1.3}>
        <Grid container direction="column">
          <Grid item>
            <TalentProfilePicture talent={talent} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={10.7}>
        <Grid container direction="column">
          <Typography
            variant="header"
            lineHeight="20px"
            fontWeight={700}
            fontSize="17px"
          >
            {talentFullName}
          </Typography>
          <Typography>{t("profileSummary.selectWorkTitles")}</Typography>
        </Grid>
        <Grid item xs={12} mt="6px">
          <ChipList {...chipListProps} />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </>
  );
};

export default TalentWorkTitleSelector;
